import type { ReactNode } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from '../../../../shared/i18n/index.js';
import { VendorLedgerView } from '../../components/LedgerStatement.js';

/** One vendor's ledger, opened from the Sales Accounts ledger for its period. */
export function VendorLedgerPage(): ReactNode {
  const { t } = useTranslation();
  const { vendorId } = useParams<{ vendorId: string }>();
  const [params] = useSearchParams();
  return (
    <div style={{ padding: 24 }}>
      <p><Link to="/finance/ledger">{t('ledger.back')}</Link></p>
      <VendorLedgerView
        path={`/v1/payments/ledger/vendor/${encodeURIComponent(vendorId ?? '')}`}
        title={(vendor) => t('ledger.vendor.title', { vendor })}
        initialFrom={params.get('from') ?? ''}
        initialTo={params.get('to') ?? ''}
      />
    </div>
  );
}
